'use client';

import { type FC, useEffect, useState } from 'react';

import { getPromoCodes } from '@/services/promo-codes';

import {
    TableModal,
    type TableModalProps,
    type TableProps,
} from '@/components/organisms/TableModal';

const PromoCodesModal: FC<TableModalProps> = ({ ...props }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [hasError, setHasError] = useState<boolean>(false);
    const [tableData, setTableData] = useState<TableProps | undefined>(
        undefined,
    );

    useEffect(() => {
        getPromoCodes()
            .then(({ promoCodesData }) => {
                setTableData(promoCodesData);
            })
            .catch(() => {
                setHasError(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <TableModal
            {...props}
            isLoading={isLoading}
            hasError={hasError}
            tableData={tableData}
        />
    );
};

export default PromoCodesModal;
